import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useSeminar = (group: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [seminarList, setSeminarList] = useState<B2cListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.b2c.seminar.list, [location.search, group]],
    () =>
      fetcher.b2c.postProjectSeminarList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: group === 'ing'? 0 : Number(searchParams.pageSize) || INIT_PAGESIZE,
        searchValue: searchParams.search ? String(searchParams.search) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
        pm: searchParams.pm ? String(searchParams.pm) : '', 
        group: group,
      }),
    {
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setSeminarList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { seminarList, searchResult, refetch };
};

export default useSeminar;
